import React from "react"

import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';


const images = ["signal_box", "coaling_stage","ruined_cottage",
    "loco_shed", "hoist", "crane", "hut", "privy", "ticket_office", "barracks", "single_fairlie", "009_water_towers"].map((name) => ({
    src: `./images/gallery/${name}.jpeg`
}));

class App extends React.Component {
  state = {
    name: ""
  }



  componentDidMount() {
      console.log(`REACT_APP_API is ${process.env.REACT_APP_API}`)
      this.setState({name: "App.js"});
      fetch(process.env.REACT_APP_API)
          .then(res => res.json())
          .then(data => {
              this.setState({name: "App.js", data: data});
              console.log(JSON.stringify(data))
          })


  }

  render() {

    return ( this.state.data &&
        <div>
            <div>
                <h1>Mark Holcroft Modelworks</h1>
                <p>Mark Holcroft Modelworks - 009 & O16.5 Models</p>
                <div>
                    <h2>Gallery</h2>
                    <div>
                        <Carousel images={images} style={{height: 512, width: 512}}/>
                    </div>
                </div>
                <div>
                    <h2>Models to buy</h2>
                    <ul>
                        {this.state.data.map(m => (<li><a target="_blank" href={m.ebay}>{m.description}</a></li>))}
                    </ul>
                </div>
                <div>
                    <h2>Online Stores</h2>
                    <ul>
                        <li><a target="_blank" href="https://www.ebay.co.uk/usr/mark.holcroft.modelworks">Ebay</a></li>
                    </ul>
                    <ul>
                        <li><a target="_blank"
                               href="https://enwinsmodels.co.uk/product-category/lineside-products/mark-holcroft-designs/">Enwins
                            3D models</a></li>
                    </ul>
                    <ul>
                        <li><a target="_blank"
                               href="https://www.moorviewmodels.co.uk/">Moor View
                            Models</a></li>
                    </ul>
                    <ul>
                        <li><a target="_blank"
                               href="https://thetraingirl.com.au/">In Australia, The Train Girl has some of my designs
                            for sale.</a></li>
                    </ul>

                </div>

                <div>
                    <h2>Model STLs to download</h2>
                    <ul>
                        {this.state.data.map(m => (<li><a target="_blank" href={m.stl}>{m.description}</a></li>))}
                    </ul>
                </div>

            </div>
            <div>
                <p>Copyright (c) 2023,2024 Mark Holcroft.</p>
                <p>Email: <a href='mailto:models@mh-modelworks.co.uk'>models@mh-modelworks.co.uk</a></p>
                <p>Instagram: <a href='https://www.instagram.com/mark.holcroft.modelworks/'>@mark.holcroft.modelworks</a></p>
    </div>
        </div>
    )
  }
}

export default App